import { render, staticRenderFns } from "./UserFilter.vue?vue&type=template&id=2111269d&"
import script from "./UserFilter.vue?vue&type=script&lang=ts&"
export * from "./UserFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib'
installComponents(component, {VSwitch})
